import React from 'react';

const Main = () => {
  return (
    <div className="flex flex-col text-center justify-center mt-28 mb-30">
      <h2 className="flex text-7xl md:text-9xl font-bold uppercase justify-center content-center mx-auto">
        Ayaka Bando
      </h2>
      <h3 className="flex job-title text-5xl md:text-6xl mt-4 justify-center sm:w-8/12 lg:w-full mx-auto">
        Full-stack Web Developer
      </h3>
      <p className="text-lg mt-4 justify-center w-8/12 mx-auto">
        With a diverse background in education and the restaurant industry,
        paired with my expertise in history and international relations, I excel
        at creating digital apps and gaining a profound understanding of complex
        concepts.
      </p>
    </div>
  );
};

export default Main;
